export default __webpack_public_path__ + "static/media/repeatingBackground.f9ff32b7.svg";